module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "custom-tb-highlight"
  }, [_c('tr', _vm._l((_vm.limitHighlight()), function(item) {
    return _c('td', {
      staticClass: "text-center custom-td-highlight"
    }, [_c('img', {
      staticClass: "img custom-img-highlight",
      attrs: {
        "src": item.icon
      }
    })])
  }), 0), _c('tr', {
    staticStyle: {
      "vertical-align": "text-top"
    }
  }, _vm._l((_vm.limitHighlight()), function(item) {
    return _c('td', {
      staticClass: "text-center custom-td-highlight"
    }, [_c('p', {
      staticClass: "txt-highlight"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8156576","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/Highlight.vue
// module id = 1659
// module chunks = 0